import axios from 'axios'
import jwt_decode from 'jwt-decode'
import store from '@/store'
import router from '@/router'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use(
    async (config) => {
        let token = store.state.auth.token;
        const useAuth = config.hasOwnProperty('useAuth') ? config.useAuth : true 
        try {
            const language = localStorage.getItem('language')
            config.headers['Accept-Language'] = (language != null) ? language : navigator.language.split('-')[0]

            if (useAuth) {
                const decodedToken = jwt_decode(token)
                const timeNow = Math.round(new Date() / 1000)
                if (parseInt(timeNow) >= parseInt(decodedToken.exp)) {
                    await store.dispatch('auth/refreshToken')
                    token = store.state.auth.token
                }
            }

            if (useAuth && token.length) config.headers['Authorization'] = `Bearer ${ token }`
        } catch (e) {
            token = ''
        } finally {
            if (!token.length && useAuth) {
                // Clear token and redirect
                store.commit('auth/logout', null, { root: true })
                router.push('/login').catch(err => {})
            }
            return config
        }
    }, 
    (error) => {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    response => response,
    error => {
        try {
            let response = error.response && error.response
            let config = response && response.config
            if (config && config.url.includes('/auth/token/refresh') && response.status === 401) {
                // Clear token and redirect
                store.commit('auth/logout', null, { root: true })
                router.push('/login').catch(err => {})
            }
        } catch(e) {
            
        } finally {
            return Promise.reject(error)
        }
    },
)